import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { styled } from '@mui/material/styles'

export const GuideDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    borderRadius: 12,
    maxWidth: 520,
    width: '100%',
    margin: theme.spacing(2),
  },
}))

export const GuideDialogTitle = styled(DialogTitle)(({ theme }) => ({
  paddingBottom: theme.spacing(1),
  fontWeight: 700,
}))

export const GuideEnvironmentBadge = styled('p')(({ theme }) => ({
  margin: 0,
  marginBottom: theme.spacing(1.5),
  padding: theme.spacing(0.75, 1.25),
  display: 'inline-block',
  backgroundColor: 'rgba(118, 167, 65, 0.15)',
  color: '#3d6b1e',
  borderRadius: 8,
  fontSize: 13,
  fontWeight: 600,
}))

export const GuideIntroduction = styled('p')(({ theme }) => ({
  margin: 0,
  marginBottom: theme.spacing(2),
  fontSize: 15,
  lineHeight: 1.5,
  color: theme.palette.text.secondary,
}))

export const GuideStepsList = styled('ol')(({ theme }) => ({
  margin: 0,
  paddingLeft: theme.spacing(2.5),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.25),
  fontSize: 15,
  lineHeight: 1.45,
}))

export const GuideNotesList = styled('ul')(({ theme }) => ({
  margin: theme.spacing(2, 0, 0),
  paddingLeft: theme.spacing(2.5),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  fontSize: 13,
  lineHeight: 1.4,
  color: theme.palette.text.secondary,
}))

export const GuideDialogContent = styled(DialogContent)(({ theme }) => ({
  paddingTop: theme.spacing(1),
}))

export const GuideDialogActions = styled(DialogActions)(({ theme }) => ({
  padding: theme.spacing(1.5, 2, 2),
  gap: theme.spacing(1),
  flexWrap: 'wrap',
}))

export const GuidePrimaryButton = styled('button')(({ theme }) => ({
  border: 0,
  borderRadius: 8,
  padding: theme.spacing(1, 2),
  backgroundColor: '#76A741',
  color: '#fff',
  fontWeight: 600,
  fontSize: 14,
  cursor: 'pointer',
}))

export const GuideSecondaryButton = styled('button')(({ theme }) => ({
  border: '1px solid rgba(0,0,0,0.2)',
  borderRadius: 8,
  padding: theme.spacing(1, 2),
  backgroundColor: '#fff',
  color: theme.palette.text.primary,
  fontWeight: 500,
  fontSize: 14,
  cursor: 'pointer',
}))
